import styled from 'styled-components';

const RoundedInput = styled.input`
    width: 100%;
    padding: 16px 20px;
    border: 1px solid #ddd;
    border-radius: 25px;
    font-size: 16px;
    background-color: #fff;
    transition: all 0.3s ease;
    text-align: center;
    box-sizing: border-box;
    letter-spacing: 0;

    &:focus {
        outline: none;
        border-color: #007acc;
        box-shadow: 0 0 20px rgba(0, 122, 204, 0.2);
        transform: scale(1.02);
    }

    &::placeholder {
        color: #999;
        font-style: italic;
    }
`;

export default RoundedInput;
